export default {
  english: {
    label: 'Share on Facebook',
  },
  french: {
    label: 'Partager sur Facebook',
  },
  arabic: {
    label: 'انشر على Facebook',
  },
  hebrew: {
    label: 'שתף בMeta',
  },
  persian: {
    label: 'در فیسبوک به اشتراک بگذارید',
  },
}
